import { toast } from 'react-toastify'
import { type FocusBuilding } from '../../../../../../models/FocusBuilding'
import { Modal } from '../../../../../customComponents/Modal'
import { DeleteFocusBuilding } from '../../../../../../services/AnnualPlanService'

interface Props {
  focusBuilding: FocusBuilding
  onClose: () => void
  onConfirm: () => void
}

export const DeleteFocusBuildingModal = (props: Props): JSX.Element => {
  const handleDeleteFocusBuilding = async (): Promise<void> => {
    if (props.focusBuilding == null) {
      toast.error('Error Deleting Focus Building')
      props.onClose()
      return
    }
    const { success, errors } = await DeleteFocusBuilding(props.focusBuilding.id, props.focusBuilding.isUpdate)

    if (!success) {
      errors.forEach(e => toast.error(e))
      props.onClose()
      return
    }

    toast.success('Focus Building Deleted')
    props.onConfirm()
  }

  return <>
    <Modal
      open={true}
      onConfirm={handleDeleteFocusBuilding}
      onClose={props.onClose}
      title='Are you sure?'
      cancelButtonText='No, Cancel'
      confirmButtonText='Yes, Delete'
      data-testid='confirmDeleteFocusBuildingModal'
      bodyContent={'Are you sure you want to delete this item?'}
      maxWidth='xs'
    />
  </>
}
